export default __webpack_public_path__ + "static/getting03-f693bba74908c81fb7f4bdc6e9da239c.png";